import { Text } from 'components/Text'

export const InputLabel = ({
  children,
  ...rest
}: {
  children: string
  htmlFor?: string
  id?: string
}) => {
  return (
    <Text as="label" size="headline" weight="medium" color="tertiary-900" align="center" {...rest}>
      {children}
    </Text>
  )
}
